import React from 'react'
import PropTypes from 'prop-types'
import { SERVICE_LABEL_WHOLESALER } from '../Helper/constants.js'
import SuccessMessage from '../Modules/SuccessMessage.jsx'
import { getWholesalerLabel } from '../Helper/helper.js'
function InsightsThoughtLeadership({
  thoughtLeaderships,
  wholesalerLabels,
  success,
  userSubscriptionProfile,
  handleSubscribe,
}) {
  const getFrequency = (frequency) => {
    switch (frequency) {
      case 'Daily':
        return '1'
      case 'Weekly':
        return '2'
      case 'Bi-Weekly':
        return '3'
      case 'Monthly':
        return '4'
      case 'Quarterly':
        return '5'
      case 'Occasional':
        return '6'
      default:
        return '0'
    }
  }
  return (
    thoughtLeaderships.length > 0 && (
      <React.Fragment>
        <h3 className="u-marginBottom3gu">
          Thought Leadership{' '}
          <span className="u-marginLeft1gu u-textNormal u-textSecondary">
            Round out your perspective and subscribe to insights from our
            thought leaders.
          </span>
        </h3>
        {success && <SuccessMessage></SuccessMessage>}
        <div
          id="Insights-thought-leadership"
          className="Grid-striper u-marginHoriz2gu"
          data-analytics="cesc-Thought-Leadership"
        >
          {thoughtLeaderships
            .sort((a, b) =>
              (getFrequency(a.frequency) + a.name || '').localeCompare(
                getFrequency(b.frequency) + b.name || '',
                'en',
                {
                  sensitivity: 'base',
                }
              )
            )
            .map((thoughtLeadership) => {
              getWholesalerLabel(
                wholesalerLabels,
                thoughtLeadership.wholesalerLabel
              )

              return (
                <div
                  key={thoughtLeadership.id}
                  className="Grid Grid--withGutter u-paddingHoriz1gu u-paddingVert3gu"
                >
                  <div className="u-size8of12 u-sm-sizeFull u-marginTop1gu">
                    <input
                      id={'thoughtCheckBox' + thoughtLeadership.id}
                      checked={thoughtLeadership.checked}
                      onChange={handleSubscribe}
                      value={thoughtLeadership.id}
                      type="checkbox"
                      className="Subscription-checkbox"
                      data-analytics="cesc-subscribe-checkbox"
                    ></input>
                    <label htmlFor={'thoughtCheckBox' + thoughtLeadership.id}>
                      <h4 className="u-marginLeft2gu u-marginRight2gu">
                        {thoughtLeadership.name}
                        {userSubscriptionProfile.role ===
                          SERVICE_LABEL_WHOLESALER &&
                          thoughtLeadership.wholesalerLabel && (
                            <div className="From-you u-marginBottom2gu u-marginLeft1gu u-inlineBlock u-bgColorLight u-paddingHoriz2gu u-textNormal">
                              <div className="u-textSizeMsrm1">
                                {
                                  (
                                    wholesalerLabels.find(
                                      (label) =>
                                        label.key ===
                                        thoughtLeadership.wholesalerLabel
                                    ) || { label: '' }
                                  ).label
                                }
                              </div>
                            </div>
                          )}
                      </h4>
                    </label>
                    <p className="u-marginTop1gu u-marginLeft5gu">
                      {thoughtLeadership.description}
                    </p>
                  </div>
                  <div className="u-size2of12 u-sm-size3of12 u-marginTop1gu u-sm-marginTop3gu u-sm-marginLeft5gu u-textCenter u-sm-textLeft">
                    <h5 className="u-textNoTransform u-paddingVert2gu u-textSizeMsr">
                      {thoughtLeadership.frequency}
                    </h5>
                  </div>
                  <div className="u-size2of12 u-sm-size3of12 u-sm-marginTop2gu u-textCenter u-sm-textLeft">
                    {thoughtLeadership.previewLink && (
                      <a
                        className="Button Button--tertiary Preview-btn u-textNoTransform u-textKernDefault"
                        data-tracking="secondary"
                        href={thoughtLeadership.previewLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Preview
                      </a>
                    )}
                  </div>
                </div>
              )
            })}
        </div>
      </React.Fragment>
    )
  )
}
InsightsThoughtLeadership.propTypes = {
  thoughtLeaderships: PropTypes.array,
  wholesalerLabels: PropTypes.array.isRequired,
  success: PropTypes.bool,
  userSubscriptionProfile: PropTypes.object.isRequired,
  handleSubscribe: PropTypes.func.isRequired,
}
export default InsightsThoughtLeadership
